import React from 'react';
import { BadgeCheck } from 'lucide-react';

const VerifiedBadge = ({ user }) => {
  if (!user || user.status !== 'single' || !user.isVerified) return null;
  
  return (
    <div className="inline-flex items-center" title="Verified Single User">
      <BadgeCheck className="w-4 h-4 ml-1 text-blue-500 fill-blue-50" />
    </div>
  );
};

export default VerifiedBadge;
